/**
 * Ponto único de telemetria "aviso" da JusCalc Completa.
 *
 * Existe porque `erros/mensagens.ts` e `payload/lerResposta.ts` repetiam o mesmo
 * bloco (nível `warning`, tag `feature: juscalc-completa`, try/catch de proteção)
 * com o mesmo comentário sobre o tipo `Severity` do @sentry/react 6.x.
 */
import * as Sentry from '@sentry/react';
import { redigirExtra } from './errosRedigir';
import type { Severity } from '@sentry/react';

export const TAG_FEATURE = 'juscalc-completa';

/**
 * Registra um aviso no Sentry. Nunca lança: telemetria não pode quebrar a UI.
 * @param action valor da tag `action` (agrupa o evento).
 */
export const capturarAviso = (
  mensagem: string,
  action: string,
  extra?: Record<string, unknown>,
) => {
  try {
    Sentry.captureMessage(mensagem, {
      // @sentry/react 6.x tipa `level` como enum Severity; o valor em runtime é a mesma string
      level: 'warning' as Severity,
      tags: { feature: TAG_FEATURE, action },
      // BB12 (ADR-032): texto livre do `extra` sai truncado e sem sequência de 6+ dígitos.
      extra: redigirExtra(extra),
    });
  } catch {
    // telemetria nunca quebra a UI
  }
};
